import React, { Component } from 'react';

import PropTypes from 'prop-types';

import CanvasMenuButton from '../menu/CanvasMenuButton';
import CanvasMenuDropDown from '../menu/CanvasMenuDropDown';

import './CanvasLayerOrder.scss';

export default class CanvasLayerOrder extends Component {
  static propTypes = {
    canvasRef: PropTypes.object,
    updateInfo: PropTypes.func
  };

  order(method) {
    const { canvasRef } = this.props;

    const activeObjects = canvasRef.getActiveObjects();

    activeObjects.forEach((object) => {
      canvasRef.setActiveObject(object);
      method(object, canvasRef);
    });

    canvasRef.discardActiveObject();
    canvasRef.renderAll();
  }

  bringToFront = () => {
    this.order((object) => object.bringToFront());
    this.props.updateInfo();
  };

  sendToBack = () => {
    this.order((object) => object.sendToBack());
    this.props.updateInfo();
  };

  render() {
    return (
      <div className="layer-order">
        <CanvasMenuDropDown
          className="text-menu__button--large"
          icon="combined-shape"
          toolTip="canvas-editor.layer-order.title"
        >
          <CanvasMenuButton
            className="text-menu__button--large"
            onClick={this.bringToFront}
            toolTip="canvas-editor.layer-order.front"
            icon="combined-shape-front"
            label="canvas-editor.layer-order.front"
          />

          <CanvasMenuButton
            className="text-menu__button--large"
            onClick={this.sendToBack}
            toolTip="canvas-editor.layer-order.back"
            icon="combined-shape-back"
            label="canvas-editor.layer-order.back"
          />
        </CanvasMenuDropDown>
      </div>
    );
  }
}
